export default __webpack_public_path__ + "static/silka-medium-webfont-1109c9c2dcc6fa529e0497e436acc383.woff";